import { Button, Card, Field, Input, Textarea } from '@fluentui/react-components';
import { useState } from 'react';
import { PageHeader } from '../../common/PageHeader';
import { LoadingState } from '../../common/LoadingState';
import { ErrorState } from '../../common/ErrorState';
import { useExchangeRate } from '../../../hooks/useExchangeRate';
import { ExchangeRateHistory } from './ExchangeRateHistory';

export const ExchangeRatePage = () => {
  const { rates, currentRate, loading, error, reload, createCurrentRate } = useExchangeRate();
  const [rate, setRate] = useState(currentRate?.cr_crm_rate.toString() ?? '3.158');
  const [notes, setNotes] = useState('');
  const [effectiveFrom, setEffectiveFrom] = useState(new Date().toISOString().slice(0, 10));

  if (loading) return <LoadingState label="Loading exchange rates..." />;
  if (error) return <ErrorState message={error} onRetry={() => void reload()} />;

  return (
    <div>
      <PageHeader title="Exchange rates" subtitle="Manage USD to TND history and current fixing" />
      <Card>
        <p><strong>Current rate:</strong> {currentRate?.cr_crm_rate ?? 'N/A'}</p>
        <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
          <Field label="Rate"><Input type="number" value={rate} onChange={(_, data) => setRate(data.value)} /></Field>
          <Field label="Effective from"><Input type="date" value={effectiveFrom} onChange={(_, data) => setEffectiveFrom(data.value)} /></Field>
          <Field label="Notes"><Textarea value={notes} onChange={(_, data) => setNotes(data.value)} rows={1} /></Field>
        </div>
        <Button appearance="primary" onClick={() => void createCurrentRate(Number(rate), effectiveFrom, notes)} style={{ marginTop: 12 }}>Set current rate</Button>
      </Card>
      <Card style={{ marginTop: 16 }}>
        <ExchangeRateHistory items={rates} />
      </Card>
    </div>
  );
};
